import React from 'react';
type Objection = {
  question: string;
  answer: string;
};
const objections: Objection[] = [{
  question: 'No soy experta.',
  answer: 'Perfecto. Las personas compran soluciones prácticas, no diplomas.'
}, {
  question: 'No tengo tiempo.',
  answer: 'Por eso es 7 días y en bloques pequeños. Esto está hecho para tu realidad.'
}, {
  question: 'Me da pena vender.',
  answer: 'Aquí no vendes como "vendedora". Vendes como mujer ayudando a otras con algo útil.'
}, {
  question: 'No sé diseñar.',
  answer: 'Gamma App se encarga del look profesional. Tú solo sigues instrucciones.'
}];
export function ProductSection() {
  return <section className="py-8 px-6 bg-[#FFF8F8]" data-id="element-163">
      <div className="max-w-xl mx-auto" data-id="element-164">
        {/* Header */}
        <div className="text-center mb-5" data-id="element-165">
          <h2 className="text-2xl md:text-3xl font-bold text-[#222222] mb-1" data-id="element-166">
            "Pero yo…"
          </h2>
          <p className="text-sm text-gray-500 italic" data-id="element-167">
            (lo que piensan casi todas al inicio)
          </p>
        </div>

        {/* Objection Cards */}
        <div className="space-y-3" data-id="element-168">
          {objections.map((item, index) => <div key={index} className="bg-[#FDF3F3] rounded-xl p-4" style={{
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)'
        }} data-id="element-169">
              <h3 className="text-[#CC0055] font-bold text-[15px] mb-1" data-id="element-170">
                "{item.question}"
              </h3>
              <p className="text-[#444444] text-[13px] leading-relaxed" data-id="element-171">
                — {item.answer}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}